import ApprovalResultRow from "./ApprovalResultRow";
import DataTable from "./DataTable";

export default function ApprovalTable({ results, assets, fetchAssets, database }) {
  if (!results || results.length === 0) {
    return <p className="ds-empty">No LV positions to analyse.</p>;
  }
  return (
    <div>
      <DataTable className="aa-table">
        <thead>
          <tr>
            <th>Position</th>
            <th>LV Title</th>
            <th>Specs</th>
            <th>Z-Number</th>
            <th>Z-Document</th>
            <th>Status</th>
            <th>Score</th>
            <th>Page</th>
          </tr>
        </thead>
        <tbody>
          {results.map((r, i) => (
            <ApprovalResultRow key={i} result={r} assets={assets} fetchAssets={fetchAssets} database={database} />
          ))}
        </tbody>
      </DataTable>
      <p className="ds-help aa-hint">Click a row to expand conditions and source passages.</p>
    </div>
  );
}
